import { put, takeLatest } from "redux-saga/effects";
import { actionTypes } from "Redux/services/actionTypes";
import apiCall from "Redux/services/apiCall";
import { API_API_LOGS, API_LOGS } from "Redux/services/apiTypes";

// ----- Get API_LOGS Watcher -----
export function* watchApiLogsSaga() {
  yield takeLatest(actionTypes.GET_API_LOGS_METHOD, getApiLogsSaga);
}

// ----- Saga -----
function* getApiLogsSaga(action) {
  try {
    let url = {
      type: API_LOGS + action.payload.query,
      payload: action.payload,
      apiType: "GET",
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.GET_API_LOGS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.GET_API_LOGS_FAIL, payload: error });
  }
}
